<div class="callout callout-{{calloutStyle}}" role="alert">
    <h3 class="callout-heading" *ngIf="title">
        <i class="fa {{icon}}" *ngIf="icon"></i>
        {{title}}
    </h3>
    <ng-content></ng-content>
</div>
